import { useState } from "react";

import Expander from "@amzn/meridian/expander";

export default function ControlledExpander(props) {
  const [open, setOpen] = useState(!!props.openOnMount);

  return <Expander data-testid="expander" open={open} onChange={setOpen} {...props} />;
}
